import styled from 'styled-components';
import { FormatHour } from 'src/components/common/FormatDate';
import { media } from 'src/styles/designs';

export interface EventPageAgendaTimeslotDateProps {
  startDate: string;
  endDate: string;
}

const Container = styled.div`
  min-width: 130px;
  margin-right: 20px;
`;

const Text = styled.span`
  letter-spacing: 0.08em;
  font-size: 18px;
  line-height: 21px;
  font-weight: 300;
  color: ${({ theme }) => theme.text.palette.secondary};

  ${media.w.lessThan.desktop} {
    font-size: 14px;
    line-height: 21px;
    color: ${({ theme }) => theme.text.palette.accent};
  }
`;

export const EventPageAgendaTimeslotDate = ({
  startDate,
  endDate,
}: EventPageAgendaTimeslotDateProps) => {
  return (
    <Container>
      <Text>
        <FormatHour>{startDate}</FormatHour>
        &nbsp;-&nbsp;
        <FormatHour>{endDate}</FormatHour>
      </Text>
    </Container>
  );
};
